import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../../utils";
import { BASE_URL } from "../../../request";
import SortDirection from "react-virtualized/dist/commonjs/Table/SortDirection";

const ModuleDefinition = {
  name: "Services",
  entityName: "services",
  filterFields: ["name", "description"],
  restConfig: {
    baseURL: `${BASE_URL}`,
    dataField: "content",
    create: {
      url: () => "api/services",
      method: "post",
    },
    fetch: {
      url: ({ id }) =>
        `api/services${id ? "/" + id : "?size=10000"}`,
      method: "get",
    },
    update: {
      url: ({ id }) => `api/services/${id}`,
      method: "put",
    },
    delete: {
      url: ({ id }) => `api/services/${id}`,
      method: "delete",
    },
  },
  entities: [],
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "translations",
  },
  allowCreate: false,
  allowClone: false,
  allowEdit: false,
  allowDelete: false,
  allowExport: true,
  exportFileName: "crm_services_export",
  sorting: {
    property: "name",
    sortable: true,
    sortDirection: SortDirection.ASC,
  },
  reorder: false,
  showTotalRecords: true,
  fields: {
    list: [
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "name",
        displayName: "Nombre",
        width: 300,
        order: 10,
      },
      {
        fieldName: "description",
        displayName: "Notas",
        width: 500,
        order: 20,
      },
    ],
    form: [
      {
        fieldName: "name",
        displayName: "Nombre",
        widget: "input",
        required: true,
      },
      {
        fieldName: "description",
        displayName: "Notas",
        widget: "input",
      },
    ],
  },
  validation: {
    name: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
